import { render, staticRenderFns } from "./PaymentRecords.vue?vue&type=template&id=6a6e621e&scoped=true"
import script from "./PaymentRecords.vue?vue&type=script&lang=js"
export * from "./PaymentRecords.vue?vue&type=script&lang=js"
import style0 from "./PaymentRecords.vue?vue&type=style&index=0&id=6a6e621e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6e621e",
  null
  
)

export default component.exports